import {
    number,
    shape,
    string,
} from 'prop-types';

const PhotoType = shape({
    id: number,
    legacy_s3_bucket: number,
    organization_salesforce_id: string,
    s3_key: string,
    s3_thumbnail_key: string,
    sponsor_advertiser_id: number,
    thumbnailUrl: string,
    url: string,
});

export default PhotoType;
